import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import allActions from "../../../actions";

//Controllers

import { headerSearch, unoTheme } from '../../../assets/styles/unoTheme';

import { IconButton } from "@material-ui/core";
import Add from "@material-ui/icons/Add";
import Remove from '@material-ui/icons/HighlightOff';
import EditIcon from '@material-ui/icons/Edit';
import DoneIcon from '@material-ui/icons/Done';
import PrintIcon from '@material-ui/icons/Print';
import { LocalBenchMarksAPI } from "../../../API/local_benchmaks";
import { AlmBenchsAPI } from "../../../API/alm_benchs";
import { getAssetInfos } from "../../../controllers/AssetsController";
import MyTable from "../../utils/MyTable";
import MyTextField from "../../utils/MyTextField";
import UnoButton from "../../utils/UnoButton";
import SelectAlmBenchmarkModal from "../../modals/SelectAlmBenchmarkModal";
import { reportTypes } from "../../utils/ReportTypes";
import { applyMaskAmount } from "../../utils/utils";
import DefaultScrollWithHeaderContent from '../../utils/DefaultScrollWithHeaderContent';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column'
    },
    green: {
        color: unoTheme.greenMoney
    },
    red: {
        color: unoTheme.redMoney,
    },
    headerSearch: headerSearch,
    rightHeader: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'end',
    },
    actionCell: {
        width: '48px',
    },
    totalRow: {
        '& .MuiTableCell-root': {
            borderBottom: 'unset',
            color: 'white',
            background: unoTheme.mainColor,
        },
    },
}));

export default function AlmScreen() {

    const classes = useStyles();
    const dispatch = useDispatch();

    const clientOn = useSelector(state => state.clientOn)

    const [innerLoad, setInnerLoad] = useState({
        emptyMessage: "",
        loadMessage: "Carregando ALM...", size: "small"
    });

    const [allBenchmarks, setAllBenchmarks] = useState(null);

    //Mapa benchmark_comdinheiro -> soma de balance_now e total da carteira
    const [balanceByBenchmark, setBalanceByBenchmark] = useState({});
    const [totalBalance, setTotalBalance] = useState(0);

    //Linhas da tabela ALM
    const [rows, setRows] = useState([]);

    const [benchmarkModalOpen, setBenchmarkModalOpen] = useState(false);

    function toNumber(value) {
        if (value == null || value === '') return 0;
        const parsed = parseFloat(String(value).replace(',', '.'));
        return isNaN(parsed) ? 0 : parsed;
    }

    function computeAtualForBenchmark(comdinheiroName, mapBalances = balanceByBenchmark, total = totalBalance) {
        if (!total || !comdinheiroName) return 0;
        const balance = mapBalances[comdinheiroName] || 0;
        return (balance / total) * 100;
    }

    async function doGetInitialData() {

        setInnerLoad({
            loadMessage: "Carregando ALM...", size: "small"
        });

        const month = clientOn.client.selectedPortfolioMonth;
        const year = clientOn.client.selectedPortfolioYear;

        //1) Benchmarks disponíveis
        const responseBenchmarks = await LocalBenchMarksAPI.getLocalBenchmarks();
        const benchmarks = responseBenchmarks.success ? responseBenchmarks.body.rows : [];
        setAllBenchmarks(benchmarks);

        //2) Saldos da carteira agrupados por benchmark
        const mapBalances = {};
        let total = 0;
        const responseAssets = await getAssetInfos(clientOn.client.id, month, year, null, false);
        if (responseAssets && responseAssets.success) {
            const { assetsFormatted } = responseAssets;
            (assetsFormatted || []).forEach(element => {
                const balance = element.balance_now != null ? parseFloat(element.balance_now) : 0;
                if (!isNaN(balance)) {
                    total += balance;
                    if (element.benchmark_comdinheiro) {
                        mapBalances[element.benchmark_comdinheiro] =
                            (mapBalances[element.benchmark_comdinheiro] || 0) + balance;
                    }
                }
            });
        }
        setBalanceByBenchmark(mapBalances);
        setTotalBalance(total);

        //3) Linhas ALM persistidas
        const responseAlm = await AlmBenchsAPI.getAlmBenchs(clientOn.client.id, month, year);
        const almRows = responseAlm.success ? responseAlm.body.rows : [];
        const formattedRows = almRows.map(almRow => {
            const benchmark = benchmarks.find(b => b.id === almRow.local_benchmark_id);
            const comdinheiroName = benchmark ? benchmark.comdinheiro_name : null;
            return {
                id: almRow.id,
                local_benchmark_id: almRow.local_benchmark_id,
                benchmarkName: benchmark ? benchmark.name : '-',
                comdinheiro_name: comdinheiroName,
                atual: computeAtualForBenchmark(comdinheiroName, mapBalances, total),
                alm_sugestion: almRow.alm_sugestion,
                editing: false,
            };
        });
        setRows(formattedRows);

        setInnerLoad(null);
    }

    useEffect(() => {

        if (clientOn
            && clientOn.client
            && clientOn.client.id
            && clientOn.client.selectedPortfolioMonth
            && clientOn.client.selectedPortfolioYear) {
            doGetInitialData();
        }

    }, [clientOn]);

    function handleBenchmarkModalAction(benchmark) {
        if (benchmark) {
            const atual = computeAtualForBenchmark(benchmark.comdinheiro_name);
            setRows(prev => [
                ...prev,
                {
                    id: null,
                    local_benchmark_id: benchmark.id,
                    benchmarkName: benchmark.name,
                    comdinheiro_name: benchmark.comdinheiro_name,
                    atual,
                    alm_sugestion: '',
                    editing: true,
                }
            ]);
        }
        setBenchmarkModalOpen(false);
    }

    function handleChangeSugestion(index, value) {
        setRows(prev => prev.map((row, i) => i === index ? { ...row, alm_sugestion: value } : row));
    }

    function handleEditRow(index) {
        setRows(prev => prev.map((row, i) => i === index ? { ...row, editing: true } : row));
    }

    async function handleSaveRow(index) {

        const row = rows[index];
        const sugestion = toNumber(row.alm_sugestion);

        let response;
        if (row.id) {
            response = await AlmBenchsAPI.updateAlmBench({
                id: row.id,
                alm_sugestion: sugestion,
            });
        } else {
            response = await AlmBenchsAPI.createAlmBench({
                client_id: clientOn.client.id,
                local_benchmark_id: row.local_benchmark_id,
                alm_sugestion: sugestion,
                month: clientOn.client.selectedPortfolioMonth,
                year: clientOn.client.selectedPortfolioYear,
            });
        }

        if (response.success) {
            const newId = row.id || (response.body && response.body.row ? response.body.row.id : null);
            setRows(prev => prev.map((r, i) => i === index
                ? { ...r, id: newId, alm_sugestion: sugestion, editing: false }
                : r));
        } else {
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: "error",
                message: "Falha ao salvar o benchmark ALM",
            }));
        }
    }

    async function handleRemoveRow(index) {

        const row = rows[index];

        if (row.id) {
            const response = await AlmBenchsAPI.deleteAlmBench(row.id);
            if (!response.success) {
                dispatch(allActions.mainAlertActions.setMainAlert({
                    show: true,
                    type: "error",
                    message: "Falha ao remover o benchmark ALM",
                }));
                return;
            }
        }

        setRows(prev => prev.filter((r, i) => i !== index));
    }

    function doReport() {

        const totalSugestion = rows.reduce((acc, row) => acc + toNumber(row.alm_sugestion), 0);
        const totalAtual = rows.reduce((acc, row) => acc + row.atual, 0);

        dispatch(allActions.reportLoadActions.setReportLoad({
            show: true,
            reportType: reportTypes.alm.cod,
            message: 'Gerando o relatório...',
            reportData: {
                rows: rows.map(row => ({
                    benchmarkName: row.benchmarkName,
                    atual: row.atual,
                    alm_sugestion: toNumber(row.alm_sugestion),
                    gap: toNumber(row.alm_sugestion) - row.atual,
                })),
                total: {
                    atual: 100,
                    sugestion: totalSugestion,
                    gap: totalSugestion - totalAtual,
                },
            },
        }));
    }

    const currentBenchmarkIds = rows.map(r => r.local_benchmark_id);

    return (
        <div className={classes.root}>

            <div className={classes.headerSearch}>

                <Typography variant="h6" gutterBottom align="left">
                    ALM
                </Typography>

                <div className={classes.rightHeader}>

                    <UnoButton
                        size={'small'}
                        style={{ marginLeft: '16px' }}
                        onClick={() => setBenchmarkModalOpen(true)}
                        type='success'
                        startIcon={<Add />}>
                        {"BENCHMARK"}
                    </UnoButton>

                    {rows.length > 0 ?
                        <UnoButton
                            size={'small'}
                            style={{ marginLeft: '16px' }}
                            onClick={() => doReport()}
                            type='primary'
                            startIcon={<PrintIcon />}>
                            {"GERAR RELATÓRIO"}
                        </UnoButton> : null}

                </div>
            </div>
            <DefaultScrollWithHeaderContent innerLoad={innerLoad}>

                <MyTable
                    size="small"
                    heightAuto>

                    <colgroup>
                        <col width="40%" />
                        <col width="15%" />
                        <col width="15%" />
                        <col width="15%" />
                        <col width="7.5%" />
                        <col width="7.5%" />
                    </colgroup>

                    <TableHead>
                        <TableRow>
                            <TableCell align="left">{'Índice/Benchmark'}</TableCell>
                            <TableCell align="right">{'Atual (%)'}</TableCell>
                            <TableCell align="right">{'Sugerido ALM (%)'}</TableCell>
                            <TableCell align="right">{'GAP (%)'}</TableCell>
                            <TableCell align="center"></TableCell>
                            <TableCell align="center"></TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {rows.map((row, index) => {

                            const gap = toNumber(row.alm_sugestion) - row.atual;

                            return (
                                <TableRow key={'alm-row-' + index + '-' + row.local_benchmark_id}>
                                    <TableCell align="left">{row.benchmarkName}</TableCell>
                                    <TableCell align="right">{applyMaskAmount(row.atual) + ' %'}</TableCell>
                                    <TableCell align="right">
                                        {row.editing
                                            ? <MyTextField
                                                verysmall
                                                align="right"
                                                mask={['currency']}
                                                value={row.alm_sugestion}
                                                onChange={(value) => handleChangeSugestion(index, value)} />
                                            : applyMaskAmount(toNumber(row.alm_sugestion)) + ' %'}
                                    </TableCell>
                                    <TableCell
                                        align="right"
                                        className={gap >= 0 ? classes.green : classes.red}>
                                        {applyMaskAmount(gap) + ' %'}
                                    </TableCell>
                                    <TableCell align="center" className={classes.actionCell}>
                                        {row.editing
                                            ? <IconButton size="small" onClick={() => handleSaveRow(index)}>
                                                <DoneIcon />
                                            </IconButton>
                                            : <IconButton size="small" onClick={() => handleEditRow(index)}>
                                                <EditIcon />
                                            </IconButton>}
                                    </TableCell>
                                    <TableCell align="center" className={classes.actionCell}>
                                        <IconButton size="small" onClick={() => handleRemoveRow(index)}>
                                            <Remove />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            );
                        })}

                        {rows.length > 0 && (() => {

                            const totalSugestion = rows.reduce((acc, row) => acc + toNumber(row.alm_sugestion), 0);
                            const totalAtual = rows.reduce((acc, row) => acc + row.atual, 0);
                            const totalGap = totalSugestion - totalAtual;

                            return (
                                <TableRow key={'alm-row-total'} className={classes.totalRow}>
                                    <TableCell align="left">{'TOTAL'}</TableCell>
                                    <TableCell align="right">{applyMaskAmount(100) + ' %'}</TableCell>
                                    <TableCell align="right">{applyMaskAmount(totalSugestion) + ' %'}</TableCell>
                                    <TableCell align="right">{applyMaskAmount(totalGap) + ' %'}</TableCell>
                                    <TableCell align="center" className={classes.actionCell}></TableCell>
                                    <TableCell align="center" className={classes.actionCell}></TableCell>
                                </TableRow>
                            );
                        })()}
                    </TableBody>

                </MyTable>

            </DefaultScrollWithHeaderContent>

            <SelectAlmBenchmarkModal
                open={benchmarkModalOpen}
                allBenchmarks={allBenchmarks}
                currentBenchmarkIds={currentBenchmarkIds}
                handleAction={handleBenchmarkModalAction} />

        </div>
    );
}
